module.exports = __webpack_public_path__ + "static/media/teygja_framanverdlaeri_a.b8d7991e.png";